import { useQuery } from '@tanstack/react-query';
import { shippingService } from '../services/shipping.service';

export function useShippingRate(refId: string) {
  return useQuery({
    queryKey: ['shippingRate', refId],
    queryFn: () => shippingService.getShippingRate(refId),
    enabled: !!refId,
  });
}
